import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../../../graphql/types.generated';
export type AccountContactsQueryVariables = GraphQLTypes.Exact<{
  accountId: GraphQLTypes.Scalars['String']['input'];
  connectionType?: GraphQLTypes.InputMaybe<
    Array<GraphQLTypes.AccountConnectionTypeEnum> | GraphQLTypes.AccountConnectionTypeEnum
  >;
  searchContains: GraphQLTypes.Scalars['String']['input'];
  withTerminals: GraphQLTypes.Scalars['Boolean']['input'];
  displayHeadquartersAtTop?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['Boolean']['input']>;
  includeZencargo?: GraphQLTypes.InputMaybe<GraphQLTypes.Scalars['Boolean']['input']>;
}>;

export type AccountContactsQueryResult = { __typename?: 'Query' } & {
  searchAccountAndConnectionLocations?: GraphQLTypes.Maybe<
    { __typename?: 'AccountLocationConnection' } & {
      nodes: Array<
        GraphQLTypes.Maybe<
          { __typename?: 'AccountLocation' } & Pick<GraphQLTypes.AccountLocation, 'id'> & {
              label?: GraphQLTypes.Maybe<{ __typename?: 'NetworksLabelType' } & Pick<GraphQLTypes.NetworksLabelType, 'long'>>;
            }
        >
      >;
    }
  >;
  terminals?: GraphQLTypes.Maybe<
    { __typename?: 'TerminalConnection' } & {
      nodes?: GraphQLTypes.Maybe<
        Array<GraphQLTypes.Maybe<{ __typename?: 'Terminal' } & Pick<GraphQLTypes.Terminal, 'id' | 'label' | 'unlocode'>>>
      >;
    }
  >;
};

export const AccountContactsDocument = gql`
  query accountContacts(
    $accountId: String!
    $connectionType: [AccountConnectionTypeEnum!]
    $searchContains: String!
    $withTerminals: Boolean!
    $displayHeadquartersAtTop: Boolean
    $includeZencargo: Boolean
  ) {
    searchAccountAndConnectionLocations(
      accountId: $accountId
      first: 50
      searchAccountAndConnectionLocationsFiltersInput: {
        accountIds: []
        connectionType: $connectionType
        displayHeadquartersAtTop: $displayHeadquartersAtTop
        searchQuery: $searchContains
        includeZencargo: $includeZencargo
      }
    ) {
      nodes {
        id
        label {
          long
        }
      }
    }
    terminals(query: $searchContains) @include(if: $withTerminals) {
      nodes {
        id
        label
        unlocode
      }
    }
  }
`;
